import store from '@/store'
const state = {
	menu: false,
	leave: {
		show: false,
		url: null
	},
	snackbar: null,
	error: null,
	visible: true,
	clock: 0,
	mobile: false,
	mobileOS: null,
	activeUsers: [],
	activityTimeout: 30
};
const getters = {
	activeUsers: (state) => {
		return state.activeUsers
	},
	activityTimeout: (state) => {
		return state.activityTimeout;
	},
	menu: (state) => {
		return state.menu;
	},
	leave: (state) => {
		return state.leave;
	},
	snackbar: (state) => {
		return state.snackbar;
	},
	error: (state) => {
		return state.error;
	},
	visible: (state) => {
		return state.visible;
	},
	clock: (state) => {
		return state.clock;
	},
	mobile: (state) => {
		return state.mobile;
	},
	mobileOS: (state) => {
		return state.mobileOS;
	}
}
const mutations = {
	addActiveUser: (state, payload) => {
		const idx = state.activeUsers.findIndex(x => x.id == payload.id);
		payload.clock = state.clock;
		if(idx != -1) {
			state.activeUsers.splice(idx, 1);
		}
		state.activeUsers.push(payload);
	},
	removeActiveUser: (state, payload) => {
		const idx = state.activeUsers.findIndex(x => x.id == payload.id);
		if(idx != -1) {
			state.activeUsers.splice(idx, 1);
		}
	},
	clearInactiveUsers: (state) => {
		state.activeUsers.forEach((x, index) => {
			if(x.clock - state.clock > state.activityTimeout) {
				state.activeUsers.splice(index, 1);
			}
		});
	},
	setMobile: (state, payload) => {
		state.mobile = payload;
	},
	setMobileOS: (state, payload) => {
		state.mobileOS = payload;
	},
	setClock: (state, payload) => {
		state.clock = payload;
	},
	incrementClock: (state) => {
		state.clock++;
	},
	setVisible(state, payload) {
		state.visible = payload;
	},
	setMenu(state, payload) {
		state.menu = payload;
	},
	showLeave(state, url) {
		state.leave.show = true;
		state.leave.url = url;
	},
	closeLeave(state) {
		state.leave.show = false;
	},
	showSnackbar(state, payload) {
		clearTimeout(window.snackbarTimeout);
		if(state.snackbar) {
			state.snackbar = null;
		}
		this._vm.$nextTick(() => {
			state.snackbar = payload;
		})
	},
	hideSnackbar(state) {
		state.snackbar = null;
	},
	throwError(state, payload) {
		state.error = payload;
	},
	clearError(state) {
		state.error = null;
	}
}

const actions = {
	/* eslint-disable */
	async handleWhisper({_}, payload) {
		store.commit('chat/addWhisperingUser', payload);
	},
	async handlePing({_}, payload) {
		store.commit('application/addActiveUser', payload);
	},
	async handleEvent({commit, dispatch, state}, payload) {
		const auth = payload.auth;
		const event = payload.event;
		const postId = event.post_id;
		const postSeen = store.getters['wall/seenPosts'].indexOf(postId) != -1;

		let engage = true;
		if(event._event_token && window._event_token) {
			if(event._event_token == window._event_token) {
				engage = false;
			}
		}
		let postLoaded = false;
		if(store.getters['wall/posts'].findIndex(x => x.id == postId) !== -1) {
			postLoaded = true;
		}
		else if(store.getters['wall/singlePost'] && store.getters['wall/singlePost'].id == postId) {
			postLoaded = true;
		}

		async function getPost() {
			let res = {};
			await axios.get('posts/' + postId)
				.then(response => {
					res = response.data.data;
				})
				.catch(error => {
					console.log("ERROR GETTING POST", error);
					res = false;
				})
				console.log("POST", res)
			return res;
		}

		async function getComment(id) {
			// api/comments/{id}
			let res = {};
			await axios.get('comments/' + id)
				.then(response => {
					res = response.data.data;
				})
				.catch(error => {
					console.log("ERROR GETTING COMMENT", error);
					res = false;
				})
				console.log("COMMENT", res)
			return res;
		}

		async function getReaction(id) {
			let res = {};
			await axios.get('reactions/' + id)
				.then(response => {
					res = response.data.data;
				})
				.catch(error => {
					console.log("ERROR GETTING REACTION", error);
					res = false;
				})
				console.log("REACTION", res)
			return res;
		}

		console.log("EVENT", event);

		// EVENT: post_added
		if(event.event == 'post_added') {
			if(!postLoaded && engage) {
				store.commit('wall/incrementNewPostsCount');
				/*
				if(store.getters['wall/isTop']) {
					store.dispatch('wall/getPosts', null);
				}
				else {
					store.commit('wall/incrementNewPostsCount');
				}
				*/
			}
			return true;
		}

		// EVENT: post_removed
		if(event.event == 'post_removed') {
			if(postLoaded && engage) {
				store.commit('wall/removePost', {id: postId})
			}
			return true;
		}

		// EVENT: post_updated
		if(event.event == 'post_updated') {
			if(postLoaded && engage) {
				await store.dispatch('wall/reloadPost', postId);
			}
			return true;
		}

		// EVENT: poll_answer_added
		if(event.event == 'poll_answer_added') {
			if(postLoaded && engage) {
				let post = await getPost();
				store.commit('wall/setPostPoll', post.postable)
			}
			return true;
		}

		// EVENT: poll_answer_removed
		if(event.event == 'poll_answer_removed') {
			if(postLoaded && engage) {
				let post = await getPost();
				store.commit('wall/setPostPoll', post.postable)
			}
			return true;
		}

		// EVENT: poll_answer_user_added
		if(event.event == 'poll_answer_user_added') {
			if(postLoaded && engage) {
				let post = await getPost();
				store.commit('wall/setPostPoll', post.postable)
			}
			return true;
		}

		// EVENT: poll_answer_user_removed
		if(event.event == 'poll_answer_user_removed') {
			if(postLoaded && engage) {
				let post = await getPost();
				store.commit('wall/setPostPoll', post.postable)
			}
			return true;
		}

		// EVENT: problem_idea_added
		if(event.event == 'problem_idea_added') {
			if(postLoaded && engage) {
				let post = await getPost();
				store.commit('wall/setPostProblem', post.postable)
			}
		}

		// EVENT: problem_idea_removed
		if(event.event == 'problem_idea_removed') {
			if(postLoaded && engage) {
				let post = await getPost();
				store.commit('wall/setPostProblem', post.postable)
			}
		}

		// EVENT: problem_idea_updated
		if(event.event == 'problem_idea_updated') {
			if(postLoaded && engage) {
				let post = await getPost();
				store.commit('wall/setPostProblem', post.postable)
			}
		}

		// EVENT: comment_added
		if(event.event == 'comment_added') {
			let comment = await getComment(event.what_id)
			if(postLoaded && engage) {
				if(event.where_type == 'post') {
					store.commit('wall/appendCommentToPost', {comment})
				}
			}
		}

		// EVENT: comment_updated
		if(event.event == 'comment_updated') {
			if(postLoaded && engage) {
				let comment = await getComment(event.what_id)
				if(event.where_type == 'post') {
					store.commit('wall/replaceCommentInPost', {comment})
				}
			}
		}

		// EVENT: comment_removed
		if(event.event == 'comment_removed') {
			if(postLoaded && engage) {
				if(event.where_type == 'post') {
					store.commit('wall/removeCommentFromPost', {
						comment: {
							id: event.what_id,
							post: {
								id: event.post_id
							}
						}})
				}
			}
		}

		// EVENT: reaction_added
		if(event.event == 'reaction_added') {
			if(postLoaded && engage) {
				let reaction = await getReaction(event.what_id);
				if(reaction) {
					if(event.where_type == 'post') {
						reaction.post = reaction.reactionable;
						store.commit('wall/appendReactionToPost', {post: {id: reaction.post_id}, reaction: reaction})
					}
					if(event.where_type == 'comment') {
						store.commit('wall/appendReactionToComment', {comment: reaction.reactionable, reaction})
					}
					if(event.where_type == 'problemIdea') {
						store.commit('wall/appendReactionToProblemIdea', {
							postID: postId,
							problemIdeaId: event.where_id,
							reaction: reaction
						})
					}
				}
			}
		}

		// EVENT: reaction_removed
		if(event.event == 'reaction_removed') {
			if(postLoaded && engage) {
				if(event.where_type == 'post') {
					store.commit('wall/removeReactionFromPost', {
						post: {
							id: postId
						},
						reaction: {
							id: event.what_id
						}
					})
				}
				if(event.where_type == 'comment') {
					store.commit('wall/removeReactionFromComment', {comment: {
						id: event.where_id,
						post_id: postId
					},
					reactionID: event.what_id})
				}
				if(event.where_type == 'problemIdea') {
					store.commit('wall/removeReactionFromProblemIdea', {
						postID: postId,
						problemIdeaId: event.where_id,
						reactionID: event.what_id
					})
				}

			}
		}

		// EVENT: reaction_updated
		if(event.event == 'reaction_updated') {
			if(postLoaded && engage) {
				let reaction = await getReaction(event.what_id);
				if(reaction) {
					if(event.where_type == 'post') {

						store.commit('wall/updateReactionToPost', {postID: postId, reaction: reaction})
					}
					if(event.where_type == 'comment') {
						store.commit('wall/updateReactionToComment', {postID: postId, commentID: event.where_id, reaction})
					}
					if(event.where_type == 'problemIdea') {
						store.commit('wall/updateReactionToProblemIdea', {
							postID: postId,
							problemIdeaId: event.where_id,
							reaction: reaction
						})
					}
				}
			}
		}
	},
	async handleNotification({commit, dispatch, state}, payload) {
		const auth = payload.auth;
		const event = payload.event;

		const postId = event.post_id;
		const notificationUuid = event.id;
		const notification = event.notification;
		const message = notification.message;

		console.log("HANDLE NOTIFICATION!", payload)




		let user = {
			id: null,
			name: null,
			email: null,
			avatar: null
		};
		if(event.user_id) {
			user.id = event.user_id;
		}
		if(event.user_name) {
			user.name = event.user_name;
		}
		if(event.user_email) {
			user.email = event.user_email;
		}
		if(event.user_avatar) {
			user.avatar = {
				url: event.user_avatar
			}
		}

		// Check if notification is already loaded
		let n = store.getters['notifications/unreadNotifications'].find(x => x.id == notification.id);
		if(!n) {
			store.commit('notifications/addPendingNotification', payload.event);
			const getN = await store.dispatch('notifications/getNotification', notification.id);
			if(getN.success) {
				n = getN.data;
				store.commit('notifications/addUnreadNotification', n);
				store.commit('notifications/removePendingNotification', payload.event);
				store.commit('notifications/incrementUnreadNotifications');
			}
		}
		if(n) {
			this._vm.$snackbar.notification(n);
		}

		console.log("HANDLE NOTIFICATION", event)
	},



	/* eslint-enable */
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
	actions
};
